/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FiShield } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { Wrapper } from '../../components/Wrapper';

const RequestDeleteAccountComponent: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-10 mb-10">
      {/* Header */}
      <div
        className="py-16 w-full text-white flex flex-col items-center justify-center"
        style={{ backgroundColor: '#16A34A' }}
      >
        <div
          className="rounded-full p-4 mb-4"
          style={{ backgroundColor: '#34AD61' }}
        >
          <FiShield size={44} />
        </div>
        <div className="flex flex-col items-center justify-center max-w-2xl">
          <h1 className="text-3xl font-semibold mb-4">
            Permintaan Penghapusan Akun
          </h1>
          <p className="text-lg text-center font-medium mb-6">
            Jika Anda ingin menghapus akun Anda, semua data pribadi dan riwayat
            aktivitas Anda akan dihapus secara permanen dari sistem kami. Proses
            ini tidak dapat dibatalkan.
          </p>
          <p className="text-sm text-center text-gray-100">
            Last updated: 26 Januari 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <iframe
              src="https://forms.gle/1qfzEz8udzX6HxsJ8"
              className="absolute top-0 left-0 w-full h-full border-0"
              title="Request Account Deletion Form"
              loading="lazy"
              aria-label="Google Form untuk permintaan penghapusan akun"
            >
              Loading form...
            </iframe>
          </div>
        </div>

        {/* Help text */}
        <div className="mt-6 text-center text-gray-600">
          <p className="text-sm">
            Mengalami masalah dengan form? Silakan hubungi support kami.
          </p>
        </div>
      </div>
    </div>
  );
};

const WrapperMain: React.FC = () => {
  return (
    <Wrapper>
      {/* Content */}
      <RequestDeleteAccountComponent />
    </Wrapper>
  );
};

const RequestDeleteAccountPage: React.FC = () => {
  return (
    <>
      <ToastContainer
        position="top-center"
        style={{ width: '60%', marginTop: '5%' }}
      />
      <WrapperMain />
    </>
  );
};

export default RequestDeleteAccountPage;
